import { Divider, Link, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import przezmorzeLogo from "../../../images/przezmorze_192x192.png";
import type { FC, PropsWithChildren } from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  readonly minWidth?: string;
}

const SignInSignUpSwitch: FC<PropsWithChildren<Props>> = ({ children, minWidth }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <Stack
      direction="column"
      spacing={5}
      sx={{
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Stack
        direction="column"
        spacing={2}
        sx={{
          alignItems: "center",
        }}
      >
        <img src={przezmorzeLogo} width={192} alt="Logo" />
        <Typography variant="subtitle1">Panel B2B dla Biur Podróży</Typography>
        <Typography variant="subtitle2">
          Jeśli nie masz konta <Link href="mailto:groups@przezmorze.pl">skontaktuj się z nami</Link>
        </Typography>
      </Stack>
      <Stack
        direction="column"
        spacing={2}
        sx={{
          alignItems: "center",
          minWidth: minWidth,
        }}
      >
        <ToggleButtonGroup
          color="primary"
          value={pathname.split("/").pop()}
          exclusive
          onChange={(_, newValue) => {
            if (newValue) {
              navigate(`/${newValue}`);
            }
          }}
          aria-label="Logowanie lub rejestracja"
        >
          <ToggleButton value="login">Logowanie</ToggleButton>
          <ToggleButton value="sign-up">Rejestracja</ToggleButton>
        </ToggleButtonGroup>
        <Divider orientation="horizontal" />
        {children}
      </Stack>
    </Stack>
  );
};

export default SignInSignUpSwitch;
